import initVueApp from "@/core.js";
const component = require(`./../views/Product.vue`).default;
initVueApp(component);
